<template>
  <div class="voteList">
    <div class="vote_shade"></div>
    <div v-if="loading" v-loading="loading" class="loading"></div>
    <div v-else>
      <el-form v-if="list && list.length" label-position="top" class="vote-form">
        <el-form-item v-for="(item, index) in list" :key="index">
          <template slot="label">
            <div>
              <el-tag type="">
                <!-- {{ index + 1 }}/{{ list.length }} -->
                {{ showIndex(index + 1) }}
              </el-tag>
              {{ item.topic_name }}
              <span style="float: right">
                {{ item.option_type === 10 ? '(单选题)' : '(多选题)' }}
              </span>
            </div>
          </template>
          <template v-slot:default>
            <el-radio-group v-if="item.option_type === 10">
              <el-radio
                v-for="(choose, i) in item.options"
                :key="i"
                style="display: block; line-height: 38px"
                :label="choose"
              >
                {{ choose.option_name }}
                <img class="img" :src="choose.option_img" alt="" />
              </el-radio>
            </el-radio-group>

            <el-checkbox-group v-model="checkboxValue" v-if="item.option_type === 20">
              <el-checkbox
                v-for="(choose, i) in item.options"
                style="display: block"
                :key="i"
                :label="choose.option_name"
              >
                {{ choose.option_name }}
                <img class="img" :src="choose.option_img" alt="" />
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-form-item>
      </el-form>
      <div v-else class="noData">暂无投票题目数据</div>
      <div style="text-align: center">
        <el-button type="info" disabled>提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getChinese } from '@/utils/util.js';
import { GetVoteByIDApi } from '@/api/releaseManagement';
export default {
  name: 'VoteList',
  props: {
    voteId: {
      type: String,
      defulat: null,
    },
  },
  data() {
    return {
      list: [],
      checkboxValue: '',
      loading: false,
    };
  },
  computed: {
    showIndex() {
      return function (index) {
        return `问题${getChinese(index)}`;
      };
    },
  },
  created() {
    this.getVoteById();
  },
  methods: {
    getVoteById() {
      try {
        this.loading = true;
        GetVoteByIDApi({ vote_id: this.voteId })
          .then((res) => {
            this.loading = false;
            this.list = res.vote_info.topics;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.vote-form.el-form--label-top .el-form-item__label {
  display: revert !important;
}
::v-deep.el-radio-group,
::v-deep.el-checkbox {
  &.el-radio-group {
    .img {
      margin-left: 30px;
    }
  }
  .img {
    display: block;
    width: 380px;
  }
  .el-radio {
    margin-right: 0;
    .el-radio__label {
      white-space: normal;
    }
  }
}
.voteList {
  position: relative;
}
.vote_shade {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99;
}
.loading {
  height: 200px;
}
.noData {
  height: 200px;
  font-size: 18px;
  line-height: 200px;
  text-align: center;
  border: 1px dashed #5c5c5c;
  margin-bottom: 20px;
  color: #606266;
}
</style>
